// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","882":"bc98253f","930":"164f4fb6"}[chunkId] || chunkId) + "." + {"195":"bc0c6a61c1fb0417","199":"c0abc05314afd8d5","316":"2cf0d2625664d51a","769":"e3370357a062c1b5","834":"55a10ad4b00f1edb","882":"9706a825a70f32f4","930":"eed36282e698e6da","966":"d79987feb5d0c389"}[chunkId] + ".js";
};